import { jsx } from "react/jsx-runtime";
import { SEOFooter } from "@zillow/zrs-cms";
const BlockSEOFooter = ({
  index,
  innerBlocks = []
}) => {
  const submenuItems = innerBlocks.map((block) => ({
    label: block.attrs.label,
    links: block.innerBlocks.map((link) => ({
      src: link.attrs.url,
      label: link.attrs.label,
      target: link.attrs.opensInNewTab ? "__blank" : ""
    }))
  }));
  return /* @__PURE__ */ jsx(SEOFooter, { submenuItems }, index);
};
export {
  BlockSEOFooter as default
};
